import {useDebugValue} from 'react';

import classNames from 'classnames';

const componentClassNamespace = 'search-form';
const componentClassName = `${componentClassNamespace}__icon`;
const componentSmallClassName = `${componentClassName}--small`;
const componentLargeClassName = `${componentClassName}--large`;

function useComponent(props) {
    const {
        iconName
    } = props;

    const className = classNames(componentClassName);

    const smallIconClassName = classNames(componentSmallClassName);
    const largeIconClassName = classNames(componentLargeClassName);

    const iconMarkupId = `${iconName}`.toUpperCase().replace('-', '_');

    const smallIconMarkupId = `${iconMarkupId}__16`;
    const largeIconMarkupId = `${iconMarkupId}__24`;

    const {
        [smallIconMarkupId]: smallIconMarkup,
        [largeIconMarkupId]: largeIconMarkup
    } = require('@homeaway/svg-defs');

    const result = {
        className,
        smallIconClassName,
        largeIconClassName,
        smallIconMarkup,
        largeIconMarkup
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
